enum ComplexidadeEnum {
  baixa = 'Baixa',
  media = 'Media',
  alta = 'Alta',
}

// Convert ComplexidadeEnum to string
// @ts-ignore
const protocoloWorkflowStatusEnumMap: { [key: string | number]: string } = {
  [ComplexidadeEnum.baixa]: 'Baixa',
  [ComplexidadeEnum.media]: 'Média',
  [ComplexidadeEnum.alta]: 'Alta',
}

export function convertComplexidadeEnumToString(value?: ComplexidadeEnum | null) {
  return protocoloWorkflowStatusEnumMap[value!]
}

export default ComplexidadeEnum
